import "expo/build/Expo.fx";
import { registerRootComponent } from "expo";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import { Platform } from "react-native";
import App from "./App";

// eslint-disable-next-line import/no-unresolved
// import { version } from "canvaskit-wasm/package.json";
import { LoadSkiaWeb } from "@shopify/react-native-skia/lib/module/web";

/**
 * ReactDOM.render is deprecated in React 18. Have updated the code to use createRoot instead.
 * https://reactjs.org/blog/2021/06/08/the-plan-for-react-18.html#new-root-api
 **/
if (Platform.OS === "web") {
  // When used on the web, we need to load the CanvasKit WASM file before rendering content
  // For simplicity, we are using a CDN to load the file, but it can be hosted on your own server as well
  // See https://shopify.github.io/react-native-skia/docs/getting-started/web for more details
  LoadSkiaWeb({}).then(async () => {
    const rootTag = createRoot(document.getElementById("root"));
    rootTag.render(createElement(App));
  });
} else {
  registerRootComponent(App);
}
